// extracted by mini-css-extract-plugin
export default {"blockwrapper":"WM","header":"XM","name":"YM","columns":"ZM","imagewrapper":"aN","addinfo":"bN","description":"cN","price":"eN","old":"fN","new":"gN","desc_d":"hN","infoblock":"iN","desc_m":"jN"};
    if(module.hot) {
      // 1713996748665
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  